import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',//去掉#，
  routes: [
    //登陆模块
    //协议详情
    { path: '/agreementDetails', name: "agreementDetails", component: (resolve) => require(['@/views/login/agreementDetails'], resolve) },
    //首页模块
    //课程详情(线上)
    { path: '/onlineCourseDetails', name: "onlineCourseDetails", component: (resolve) => require(['@/views/homepage/sharepage/onlineCourseDetails'], resolve) },
    //课程详情(线上套餐)
    { path: '/onlineMultiCourseDetails', name: "onlineMultiCourseDetails", component: (resolve) => require(['@/views/homepage/sharepage/onlineMultiCourseDetails'], resolve) },
    //课程详情(线下)
    { path: '/underlineCourseDetails', name: "underlineCourseDetails", component: (resolve) => require(['@/views/homepage/sharepage/underlineCourseDetails'], resolve) },
    //课程详情(线下)
    { path: '/oToCourseDetails', name: "oToCourseDetails", component: (resolve) => require(['@/views/homepage/sharepage/oToCourseDetails'], resolve) },
    //资讯详情
    { path: '/informationDetails', name: "informationDetails", component: (resolve) => require(['@/views/homepage/informationModule/informationDetails'], resolve) },
    // 评论详情
    { path: '/commentDetails', name: "commentDetails", component: (resolve) => require(['@/views/homepage/informationModule/commentDetails'], resolve) },
    // 自测评估
    { path: '/selfAssessment', name: "selfAssessment", component: (resolve) => require(['@/views/homepage/sharepage/selfAssessment'], resolve) },
    // 学习报告
    { path: '/learningReport', name: "learningReport", component: (resolve) => require(['@/views/homepage/sharepage/learningReport'], resolve) },
    // 模考报告(首页我的)
    { path: '/examReport', name: "examReport", component: (resolve) => require(['@/views/homepage/sharepage/examReport'], resolve) },
    // 专家诊断(首页我的)
    { path: '/diagnosisReport', name: "diagnosisReport", component: (resolve) => require(['@/views/homepage/sharepage/diagnosisReport'], resolve) },
    // 每日一练
    { path: '/everydayExercises', name: "everydayExercises", component: (resolve) => require(['@/views/homepage/sharepage/everydayExercises'], resolve) },
    // 每日倾听
    { path: '/everydayListening', name: "everydayListening", component: (resolve) => require(['@/views/homepage/sharepage/everydayListening'], resolve) },
    // 抖分视频分享
    { path: '/doufenShare', name: "doufenShare", component: (resolve) => require(['@/views/homepage/sharepage/doufenShare'], resolve) },
    // 资料下载
    { path: '/infoDownload', name: "infoDownload", component: (resolve) => require(['@/views/homepage/sharepage/infoDownload'], resolve) },
    // 广告1
    { path: '/advertisementOne', name: "advertisementOne", component: (resolve) => require(['@/views/homepage/sharepage/advertisementOne'], resolve) },
    // 广告2
    { path: '/advertisementTwo', name: "advertisementTwo", component: (resolve) => require(['@/views/homepage/sharepage/advertisementTwo'], resolve) },
    // 视频预约页
    { path: '/onlineAppointment', name: "onlineAppointment", component: (resolve) => require(['@/views/homepage/sharepage/onlineAppointment'], resolve) },
    // 协议内容页(o2o)
    { path: '/agreementCont', name: "agreementCont", component: (resolve) => require(['@/views/homepage/sharepage/agreementCont'], resolve) },
    // 协议内容页(已签署)
    { path: '/signed_agreement', name: "signedAgreement", component: (resolve) => require(['@/views/homepage/agreements/signedAgreement'], resolve) },
    // 协议内容页(未签署)
    { path: '/unsigned_agreement', name: "unsignedAgreement", component: (resolve) => require(['@/views/homepage/agreements/unsignedAgreement'], resolve) },
    // 直播分享页
    { path: '/liveRoomShare', name: "liveRoomShare", component: (resolve) => require(['@/views/homepage/sharepage/liveRoomShare'], resolve) },
    // 我的模块
    //我的二维码
    { path: '/myCode', name: "myCode", component: (resolve) => require(['@/views/mycenter/myCode'], resolve) },
    //我的二维码(新版)
    { path: '/myCodeOld', name: "myCodeOld", component: (resolve) => require(['@/views/mycenter/myCodeOld'], resolve) },
    //朋友代付
    { path: '/friendPay', name: "friendPay", component: (resolve) => require(['@/views/mycenter/friendPay'], resolve) },
    //我的主页
    { path: '/myHome', name: "myHome", component: (resolve) => require(['@/views/mycenter/myHome'], resolve) },

    //微聊模块
    //动态分享
    { path: '/friendDynamics', name: "friendDynamics", component: (resolve) => require(['@/views/weichat/friendDynamics'], resolve) },

    //学习模块
    //专项练习
    { path: '/specialExercises', name: "specialExercises", component: (resolve) => require(['@/views/study/sharepage/specialExercises'], resolve) },
    //排行榜
    { path: '/rankingList', name: "rankingList", component: (resolve) => require(['@/views/study/ranking/rankingList'], resolve) },
    //行测报告
    { path: '/surveyReport', name: "surveyReport", component: (resolve) => require(['@/views/study/sharepage/surveyReport'], resolve) },
    //申论报告
    { path: '/remarksReport', name: "remarksReport", component: (resolve) => require(['@/views/study/sharepage/remarksReport'], resolve) },

    //模考大赛-答题报告
    { path: '/answerReport', name: "answerReport", component: (resolve) => require(['@/views/study/mockexam/answerReport'], resolve) },
    //模考大赛-线上模考详情
    { path: '/onlineMockDetail', name: "onlineMockDetail", component: (resolve) => require(['@/views/study/mockexam/onlineMockDetail'], resolve) },
    //模考大赛-我的模考
    { path: '/myMock', name: "myMock", component: (resolve) => require(['@/views/study/mockexam/myMock'], resolve) },
    //模考大赛-线上模考开始
    { path: '/onlineMockStart', name: "onlineMockStart", component: (resolve) => require(['@/views/study/mockexam/onlineMockStart'], resolve) },
    //模考大赛-线上模考
    { path: '/onlineMock', name: "onlineMock", component: (resolve) => require(['@/views/study/mockexam/onlineMock'], resolve) },
    //模考大赛-线上模考首页
    { path: '/mockPkIndex', name: "mockPkIndex", component: (resolve) => require(['@/views/study/mockexam/mockPkIndex'], resolve) },



    //pk对战
    { path: '/pkVersus', name: "pkVersus", component: (resolve) => require(['@/views/study/pk/pkVersus'], resolve) },
    //pk邀请
    { path: '/pkInvite', name: "pkInvite", component: (resolve) => require(['@/views/study/pk/pkInvite'], resolve) },
    //pk
    { path: '/pkSearching', name: "pkSearching", component: (resolve) => require(['@/views/study/pk/pkSearching'], resolve) },
    //pk邀请好友
    { path: '/pkSearching1', name: "pkSearching1", component: (resolve) => require(['@/views/study/pk/pkSearching1'], resolve) },

    //pk答题
    { path: '/pkAnswerQuestion', name: "pkAnswerQuestion", component: (resolve) => require(['@/views/study/pk/pkAnswerQuestion'], resolve) },
    //pk机器答题
    { path: '/pkAnswerQuestionRobot', name: "pkAnswerQuestionRobot", component: (resolve) => require(['@/views/study/pk/pkAnswerQuestionRobot'], resolve) },

    //pk失败
    { path: '/pkSuccessFail', name: "pkSuccessFail", component: (resolve) => require(['@/views/study/pk/pkSuccessFail'], resolve) },

    //pk榜单（pk）
    { path: '/pklist', name: "pklist", component: (resolve) => require(['@/views/study/pk/pklist'], resolve) },

    //朋友列表
    { path: '/friendsList', name: "friendsList", component: (resolve) => require(['@/components/friendsList'], resolve) },


    //活动模块
    //活动页
    { path: '/courseReceive', name: "courseReceive", component: (resolve) => require(['@/views/activities/courseReceive'], resolve) },
    //下载引导
    { path: '/guidDownload', name: "guidDownload", component: (resolve) => require(['@/views/activities/guidDownload'], resolve) },
    //图书下载引导c
    { path: '/bookGuidDownload', name: "bookGuidDownload", component: (resolve) => require(['@/views/activities/bookGuidDownload'], resolve) },
    //图书下载引导新版
    { path: '/booksguidDownload', name: "booksguidDownload", component: (resolve) => require(['@/views/activities/booksguidDownload'], resolve) },
    //易面酷下载引导
    { path: '/ymkGuidDownload', name: "ymkGuidDownload", component: (resolve) => require(['@/views/activities/ymkGuidDownload'], resolve) },
    //新年活动抽签页
    { path: '/newyearActivity', name: "newyearActivity", component: (resolve) => require(['@/views/activities/newyearActivity'], resolve) },


    // 小程序相关
    { path: '/miniprogram/pay', name: "minipay", component: (resolve) => require(['@/views/miniprogram/pay'], resolve) },
    { path: '/miniprogram/payStatus', name: "minipayStatus", component: (resolve) => require(['@/views/miniprogram/payStatus'], resolve) },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js